import { createCRUDHook } from './createCRUDHook';
import {
  PartLotNumberDto,
  PartLotNumberWithPartRackBinDto,
} from 'utils/models';
import {
  CREATE_BULK_ENTITY,
  GET_RACK_BIN_DATA_WITH_LOT_NUMBERS_BY_INTERMEDIATE_PARTID,
  TBL_PART_LOT_NUMBER,
} from './apiEndPoints';
interface PartLotNumberCustomOperations {
  fetchRackBinWithLotNumberByPartId: (
    partId: number
  ) => Promise<PartLotNumberWithPartRackBinDto[]>;

  postRackBinDataByBulkEntity: (param: PartLotNumberDto[]) => Promise<boolean>;
}

const { Context, useManager, useConsumer } = createCRUDHook<
  PartLotNumberDto,
  PartLotNumberDto[],
  PartLotNumberCustomOperations
>({
  entityName: 'PartLotNumber',
  endpoint: TBL_PART_LOT_NUMBER,

  customOperations: (auth) => ({
    fetchRackBinWithLotNumberByPartId: async (partId) => {
      const res = await auth.makeAuthenticatedGet(
        TBL_PART_LOT_NUMBER +
          GET_RACK_BIN_DATA_WITH_LOT_NUMBERS_BY_INTERMEDIATE_PARTID +
          `?partId=${partId}`
      );
      return res.data;
    },

    postRackBinDataByBulkEntity: async (param) => {
      const res = await auth.makeAuthenticatedPost(
        TBL_PART_LOT_NUMBER + CREATE_BULK_ENTITY,
        param
      );
      return res.data;
    },
  }),
});

export const PartLotNumberContext = Context;
export const usePartLotNumberManager = useManager;
export const usePartLotNumber = useConsumer;
